import React from 'react';
import classNames from 'classnames/bind';
import { Tabs, TabsPropsType } from '@beef/ui-kit';
import { connect } from 'react-redux';

import { onNestedCollectionView } from 'store/ProductCatalog/actions';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

type Props = Pick<TabsPropsType, 'selectedTab' | 'tabs'> & {
  isMobile?: boolean;
  className?: string;
  onChange?: TabsPropsType['onChange'];
  onView: ({ title, tabs, id }: { title: string, tabs: TabsPropsType, id: string }) => void;
};

/**
 * Обёртка над Tabs из ui-kit.
 * Нужна для того чтобы изменить стандартное поведение для десктопа
 */
export const NestedCollections_: React.FC<Props> = ({
  selectedTab,
  tabs,
  isMobile,
  className,
  onChange,
  onView,
}) => {
  const handleView = (id: string) => {
    onView({ id, tabs });
  };

  return (
    <div className={cn('component', className, { isMobile })}>
      <Tabs
        onChange={onChange}
        tabs={tabs}
        variant="secondary"
        selectedTab={selectedTab}
        isScrollable
        noWrap
        onTabView={handleView}
      />
    </div>
  );
};

const mapDispatchToProps = {
  onView: onNestedCollectionView,
};

export const NestedCollections = connect(null, mapDispatchToProps)(NestedCollections_);

